module.exports = __webpack_public_path__ + "img/prostoLogo.2742cc0.png";